import { Component, OnInit } from '@angular/core';
import { PrizeForPrecisionService } from '../../services/prize-for-precision.service';

@Component({
  selector: 'app-price-for-precision-filters',
  templateUrl: './price-for-precision-filters.component.html',
  styleUrls: ['./price-for-precision-filters.component.scss']
})
export class PriceForPrecisionFiltersComponent implements OnInit {

  constructor(public filter_service: PrizeForPrecisionService) { }

  ngOnInit() {
  }

}
